export default function AppEntry() {
  return (
    <section id="app" className="section-py bg-background-50">
      <div className="section-container">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            移动爆料
          </h2>
        </div>

        <div className="bg-background-900 rounded-xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/20 text-primary-300 text-xs font-semibold mb-4">
                <i className="ri-smartphone-line"></i>
                移动端专属
              </span>
              <h3 className="text-xl md:text-2xl font-bold font-heading text-background-50 mb-3">
                随时随地 · 吃瓜不停
              </h3>
              <p className="text-sm text-background-300 mb-6 leading-relaxed max-w-md">
                51爆料网移动端为你提供更便捷的爆料阅读体验。推送通知让你第一时间获取最新赛事爆料，离线缓存功能让你随时随地浏览精彩内容。下载51爆料网APP，爆料快人一步！
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-lg cursor-pointer hover:bg-background-100 transition-colors">
                  <i className="ri-apple-fill text-xl text-foreground-900"></i>
                  <div className="text-left">
                    <div className="text-xs text-foreground-500">下载</div>
                    <div className="text-sm font-semibold text-foreground-900">App Store</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-lg cursor-pointer hover:bg-background-100 transition-colors">
                  <i className="ri-google-play-fill text-xl text-foreground-900"></i>
                  <div className="text-left">
                    <div className="text-xs text-foreground-500">下载</div>
                    <div className="text-sm font-semibold text-foreground-900">Google Play</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 bg-primary-500 rounded-lg cursor-pointer hover:bg-primary-600 transition-colors">
                  <i className="ri-qr-scan-line text-xl text-background-50"></i>
                  <div className="text-left">
                    <div className="text-xs text-background-200">扫码</div>
                    <div className="text-sm font-semibold text-background-50">直接下载</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-1 flex justify-center lg:justify-end p-6 md:p-8">
              <div className="relative w-56 md:w-64">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20showing%20news%20app%20interface%20with%20breaking%20news%20feed%2C%20warm%20red%20accent%20design%2C%20dark%20mode%20news%20reader%2C%20sleek%20minimal%20UI%20with%20headlines%20and%20images%2C%20professional%20app%20design%20mockup%2C%20clean%20typography%20layout&width=500&height=900&seq=app-mockup-51&orientation=portrait"
                  alt="51爆料网 移动端界面"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}